import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import routesPath from './RoutesPath';
import { GOOGLE_MAPS_ROUTES } from './constants';
import SignInPage from 'pages/SignInPage';
import { hideChatIcon } from 'services/freshchat';
import SignUpPage from 'pages/SignUpPage';
import LandingPage from 'containers/auth/LandingPage';
import SignUp from 'containers/auth/SignUp';
import DigitalOnboarding from 'containers/digital-onboarding/digitalOnboarding';
import DeclinedPage from 'containers/error-screens/DeclinedPage';
import CapitalPage from 'pages/CapitalPage';
import CardViewPage from 'pages/CardViewPage';
import PinViewPage from 'pages/PinViewPage';
import CustomerAddCOFWebViewPage from 'pages/CustomerAddCOFWebViewPage';
import AppStoreRedirectWebViewPage from 'pages/AppStoreRedirectWebViewPage';
import { loadGoogleMapsScript } from 'utils/maps';
// import LendicaWebView from 'containers/lending/LendicaWebView';

const PublicLayout = () => {
  const location = useLocation();

  useEffect(() => {
    hideChatIcon();

    // Load Google Maps script only for routes that need it
    if (GOOGLE_MAPS_ROUTES.includes(location.pathname)) {
      loadGoogleMapsScript();
    }
  }, [location.pathname]);

  return (
    <div className={'flex h-screen w-screen flex-row'}>
      <Routes>
        <Route path={routesPath.DEFAULT} element={<LandingPage />} />
        <Route path={routesPath.SIGNIN} element={<SignInPage />} />
        <Route path={routesPath.SIGN_UP_QR} element={<SignUpPage />} />
        <Route path={routesPath.SIGN_UP} element={<SignUp />} />
        <Route path={routesPath.ALL} element={<Navigate to={routesPath.SIGNIN} replace />} />
        <Route path={routesPath.DIGITAL_ONBOARDING_NAME} element={<DigitalOnboarding />} />
        <Route path={routesPath.DIGITAL_ONBOARDING_EMAIL} element={<DigitalOnboarding />} />
        <Route path={routesPath.DIGITAL_ONBOARDING_PROFESSION} element={<DigitalOnboarding />} />
        <Route path={routesPath.DIGITAL_ONBOARDING_BUSINESS_NAME} element={<DigitalOnboarding />} />
        <Route path={routesPath.DIGITAL_ONBOARDING_EMPLOYEES} element={<DigitalOnboarding />} />
        <Route path={routesPath.DIGITAL_ONBOARDING_REFERRAL_SOURCE} element={<DigitalOnboarding />} />
        <Route path={routesPath.DIGITAL_ONBOARDING_WEBSITE} element={<DigitalOnboarding />} />
        <Route path={routesPath.DIGITAL_ONBOARDING_EMAIL_ERROR} element={<DigitalOnboarding />} />
        <Route path={routesPath.DECLINED} element={<DeclinedPage />} />
        <Route path={routesPath.WAITING_LIST} element={<DigitalOnboarding />} />
        {/* <Route path={routesPath.LENDICA_WEBVIEW} element={<LendicaWebView />} /> */}
        <Route path={routesPath.CAPITAL_WEBVIEW} element={<CapitalPage isWebView={true} />} />
        <Route path={routesPath.ONBOARDING_CAPITAL_WEBVIEW} element={<CapitalPage isWebView={true} />} />
        <Route path={routesPath.CARD_DETAILS_WEBVIEW} element={<CardViewPage />} />
        <Route path={routesPath.PIN_WEBVIEW} element={<PinViewPage />} />
        <Route path={routesPath.CUSTOMER_ADD_COF_WEBVIEW} element={<CustomerAddCOFWebViewPage />} />
        <Route path={routesPath.APP_STORE_REDIRECT_WEBVIEW} element={<AppStoreRedirectWebViewPage />} />
      </Routes>
    </div>
  );
};

export default PublicLayout;
